import { FCX, Dropdown as PlatformDropdown } from "@datassential/platform-ui-lib";
import Popup from "@components/Popup";
import { ComponentProps, useMemo } from "react";
import cn from "classnames";

const Dropdown: FCX<ComponentProps<typeof PlatformDropdown> & {
    tooltipId: string;
    isInPortal?: boolean;
}> = ({
    tooltipId,
    isInPortal = true,
    ...props
}) => {
    const renderDropdown = useMemo(
        () => (
            <PlatformDropdown
                {...props}
                id={tooltipId}
                className={cn('DropdownComponent', props.className)}
            />
        ),
        [props, tooltipId],
    );

    if (isInPortal) {
        return (
            <Popup>
                {renderDropdown}
            </Popup>
        );
    }

    return renderDropdown;
};

export type DropdownProps = ComponentProps<typeof Dropdown>;

export default Dropdown;